import React from "react";
import Frame from "../../Frame/index.js";
import styles from "./FlightCardBadges.module.css";
import { mcn } from "../../../../utils/mergeClassnames.js";
export const FlightCardBadges = ({ className, children }) => {
    return React.createElement(Frame, { className: mcn(styles.flightCardBadges, className || "") }, children);
};
